import { render } from "./CardBody.vue?vue&type=template&id=0a7c5616"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"
script.render = render

export default script